import { AnalyticsSessionManager } from '@rmstransactions/components';
import { analyticsEnrolmentType } from './pushGoogleAnalyticsPage';

const transactionCleanupEvents = (): void => {
  // Google Analytics
  AnalyticsSessionManager.clearSessionID();
  AnalyticsSessionManager.clearUserID();
  AnalyticsSessionManager.clearUserLoginType();
  AnalyticsSessionManager.clearTransactionStartTime();

  analyticsEnrolmentType.clear();
};

export default transactionCleanupEvents;
